import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { $createExtendedTextNode } from '@mutiny-pkg/bin-ui/src/richtext/ExtendedTextPlugin/ExtendedTextNode';
import { LookupNode } from './LookupNode';

export type LookupItem = {
  link: {
    label: string;
    value: string; // linkColumnId
  };
  options: Array<{
    label: string;
    value: string; // refColumnId
  }>;
};

// linkColumns: Array<WorkSheetColumn>
// refSheets: Array<WorkSheet>

export function LookupPlugin({ items }: { items: LookupItem[] }) {
  const [editor] = useLexicalComposerContext();

  // The value of a lookup node consists of a link and a target property toa external entity.
  // To make it human readable, we need to rehydrate the two labels when the node is created in the editor.
  useEffect(() => {
    const lookupByValue = Object.fromEntries(items.map((item) => [item.link.value, item]));
    const referencesByValue = Object.fromEntries(items.flatMap((item) => item.options).map((ref) => [ref.value, ref]));

    return editor.registerNodeTransform(LookupNode, (node) => {
      // If the node becomes inconsistent, replace it with a normal text node instead.
      if (!node.isConsistent()) {
        node.replace($createExtendedTextNode(node.getTextContent()));
        return;
      }

      // Hydrate the label
      const link = lookupByValue[node.__linkColumnId];
      const ref = referencesByValue[node.__refLookupColumnId];
      if (link && ref) {
        node.setLabel(`🔗${link.link.label}.${ref.label}`);
      }
    });
  }, [editor, items]);

  // TODO: implement a input menu
  return null;
}
